import {
  LOAD_REPORT_DATA,
  LOAD_REPORT_DATA_SUCCESS,
  LOAD_REPORT_DATA_FAILURE,
  CLEAR_REPORT_DATA,
  LOAD_IMAGING_DATA,
  LOAD_IMAGING_DATA_SUCCESS,
  LOAD_IMAGING_DATA_FAILURE,
  LOAD_SPECIES_RANKING,
  LOAD_SPECIES_RANKING_SUCCESS,
  LOAD_SPECIES_RANKING_FAILURE,
} from "./types";
import { displayErrorNotification } from "./notifications";
import { rankSpecies } from "../utils/chartPalette";

const reportError = (err) =>
  // the service says what was wrong with the request where it can; a dropped
  // connection has only axios's "Network Error"
  err?.response?.data?.error ||
  "The report could not be loaded. Check your connection and try again.";

let reportRequests = 0;

// a load that failed, said only while it is still the report waited on
const reportFailed = (request, err) => (dispatch, getState) => {
  dispatch({ type: LOAD_REPORT_DATA_FAILURE, request });
  if (getState().report?.report?.request === request) {
    dispatch(displayErrorNotification(reportError(err)));
  }
};

/**
 * Counts for a report from POST /organization/reports/pivot. `filters` is the
 * report filter body; `pivot` the dimensions, {rows, columns}, plus any other
 * pivot options (weekStart, dateBasis).
 */
export const loadPivotReport =
  (sendOrganizationRequest, filters, pivot) => async (dispatch) => {
    const request = ++reportRequests;
    try {
      dispatch({ type: LOAD_REPORT_DATA, request });
      const response = await sendOrganizationRequest("post")({
        url: "/organization/reports/pivot",
        data: { ...pivot, filter: filters, timezone: filters?.timezone },
      });
      dispatch({
        type: LOAD_REPORT_DATA_SUCCESS,
        request,
        payload: response.data,
        generatedAt: new Date().toISOString(),
      });
    } catch (err) {
      dispatch(reportFailed(request, err));
    }
  };

/** The raw data rows for `filters`, from POST /organization/data. */
export const loadRawData =
  (downloadOrganizationDataWithRawData, filters) => async (dispatch) => {
    const request = ++reportRequests;
    try {
      dispatch({ type: LOAD_REPORT_DATA, request });
      const response = await downloadOrganizationDataWithRawData({ filters });
      dispatch({
        type: LOAD_REPORT_DATA_SUCCESS,
        request,
        payload: response.data,
        generatedAt: new Date().toISOString(),
      });
    } catch (err) {
      dispatch(reportFailed(request, err));
    }
  };

export const clearReportData = () => async (dispatch) => {
  dispatch({ type: CLEAR_REPORT_DATA });
};

// The organization's species, most-caught first over all time, which decides
// each species' chart color (utils/chartPalette.js). Loaded once per
// organization: unfiltered, so a report's own filters never change it.
export const loadSpeciesRanking =
  (sendOrganizationRequest, organization) => async (dispatch) => {
    dispatch({ type: LOAD_SPECIES_RANKING, payload: { organization } });
    try {
      const { data } = await sendOrganizationRequest("post")({
        url: "/organization/reports/pivot",
        data: { rows: ["species"], columns: [], filter: {} },
      });
      const rows = (data?.rows ?? []).map((row, r) => ({
        species: row.label[0],
        count: data.rowTotals?.[r] ?? 0,
      }));
      dispatch({
        type: LOAD_SPECIES_RANKING_SUCCESS,
        payload: { organization, labels: rankSpecies(rows) },
      });
    } catch (err) {
      // Charts still color without it - each ranks its own species - so this
      // is not worth interrupting the user over.
      console.error(err);
      dispatch({ type: LOAD_SPECIES_RANKING_FAILURE, payload: { organization } });
    }
  };

export const loadImagingData = (downloadImaging) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_IMAGING_DATA });
    let response = null;
    response = await downloadImaging({});
    dispatch({ type: LOAD_IMAGING_DATA_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: LOAD_IMAGING_DATA_FAILURE });
    console.log(err?.message);
    dispatch(displayErrorNotification(err?.message));
  }
};
